export default __webpack_public_path__ + "media/images/icons/new-linkedin-56649beda6d76f8d22a8979290d39dd5.svg";